"use client";

import React from "react";
import { motion } from "framer-motion";
import { Mail, Lock, Loader as Loader2, CircleAlert as AlertCircle } from 'lucide-react';
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Link } from "@/components/common/Link";
function LoginForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} className="flex flex-col items-center justify-center py-8 text-center">
        <div className="mb-4 flex size-12 items-center justify-center rounded-lg bg-primary/20 text-primary">
          <Loader2 className="size-6 animate-spin" />
        </div>
        <h3 className="font-default mb-2 text-xl font-semibold text-foreground">
          {successMessage}
        </h3>
        <p className="text-muted-foreground text-sm">
          请稍候，我们正在为您加载专属控制台...
        </p>
      </motion.div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-5">
      {submitError && <Alert variant="destructive" className="mb-6">
          <AlertCircle className="size-4" />
          <AlertDescription>{submitError}</AlertDescription>
        </Alert>}

      <FormField control={control} name="username" rules={{
      required: "请输入用户名或邮箱"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground">用户名 / 邮箱</FormLabel>
            <FormControl>
              <div className="relative">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-muted-foreground">
                  <Mail className="size-4" />
                </div>
                <Input placeholder="admin@msbiotech.com" className="pl-10" {...field} />
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="password" rules={{
      required: "请输入密码",
      minLength: {
        value: 6,
        message: "密码长度至少为6位"
      }
    }} render={({
      field
    }) => <FormItem>
            <div className="flex items-center justify-between">
              <FormLabel className="text-foreground">密码</FormLabel>
              <Link to="#" className="text-primary text-sm font-medium hover:underline">
                忘记密码？
              </Link>
            </div>
            <FormControl>
              <div className="relative">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-muted-foreground">
                  <Lock className="size-4" />
                </div>
                <Input type="password" placeholder="••••••••" className="pl-10" {...field} />
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <Button type="submit" disabled={isSubmitting} className="w-full" size="lg">
        {isSubmitting ? <>
            <Loader2 className="mr-2 size-4 animate-spin" />
            正在登录...
          </> : "登录"}
      </Button>
    </Form>;
}
export default function MemberLogin() {
  return <section id="memberlogin" className="bg-background relative flex min-h-[80vh] items-center justify-center overflow-hidden py-24">
      {}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="bg-primary/5 absolute -top-[20%] -right-[10%] size-[600px] rounded-lg blur-[100px]" />
        <div className="bg-secondary/30 absolute -bottom-[20%] -left-[10%] size-[500px] rounded-lg blur-[80px]" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="mx-auto w-full max-w-md">
          <Card className="border-border/50 shadow-xl backdrop-blur-sm">
            <CardHeader className="space-y-2 text-center">
              <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-xl bg-primary/10">
                <Lock className="text-primary size-6" />
              </div>
              <CardTitle className="font-default text-2xl font-bold tracking-tight text-foreground">
                会员登录
              </CardTitle>
              <CardDescription className="text-muted-foreground">
                欢迎回来，请登录您的账户以访问专属医疗资源和分销商门户。
              </CardDescription>
            </CardHeader>
            <CardContent>
              <FormProvider formId="member-login-form" sectionName="MemberLogin" defaultValues={{
              username: "",
              password: ""
            }} submitText="登录" successMessage="登录成功！正在跳转..." errorMessage="登录失败，请检查您的凭据并重试。">
                <LoginForm />
              </FormProvider>
            </CardContent>
            <CardFooter className="flex flex-col items-center justify-center space-y-4 border-t border-border/50 pt-6">
              <div className="text-muted-foreground text-sm">
                还没有账户？{" "}
                <Link to="#" className="text-primary font-medium hover:underline">
                  申请成为分销商
                </Link>
              </div>
            </CardFooter>
          </Card>
        </motion.div>
      </div>
    </section>;
}